<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <sidebarSettingsComponent></sidebarSettingsComponent>
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main col-md-8">
        <div class="col-md-12">
          <b-row>
            <b-col md="12">
              <b-card-body>
                <div class="col-md-12"><h3>Update User</h3></div>
                <!-- <b-form
                  @submit.prevent="validateForm('form-1')"
                  data-vv-scope="form-1"
                > -->
                  <div class="col-md-6 pull-left">
                    <b-form-group>
                      <label for="first name"> Name</label>
                      <b-form-input
                        type="text"
                        name="full_name"
                        v-model="customer.full_name"
                        v-validate="'required|min:3|max:30'"
                        :class="{
                          input: true,
                          'text-danger': errors.has('form-1.full_name'),
                        }"
                        placeholder="Enter Name"
                      >
                      </b-form-input>
                      <b-input-group>
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('full_name')"
                          ></i>
                        </span>
                        <span
                          style="width:240px"
                          v-show="errors.has('form-1.full_name')"
                          class="help text-danger"
                          >{{ errors.first("form-1.full_name") }}</span
                        >
                      </b-input-group>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 pull-right">
                    <b-form-group>
                      <label for="contact_no">Contact Number</label>
                      <b-input-group>
                        <b-form-input
                          class="input"
                          type="text"
                          id="contact_no"
                          name="contact_no"
                          maxlength="10"
                          v-model="customer.contact_no"
                          v-validate="'required|digits:10'"
                          :class="{
                            input: true,
                            'text-danger': errors.has('form-1.contact_no'),
                          }"
                          placeholder="Enter Contact Number"
                        >
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('contact_no')"
                          ></i>
                        </span>
                        <code
                          v-show="errors.has('form-1.contact_no')"
                          id="addmblnbrmsg"
                          class="help text-danger"
                          >{{ errors.first("form-1.contact_no") }}
                        </code>
                      </b-input-group>
                    </b-form-group>
                  </div>
                  

                  <div class="col-md-6 pull-left">
                    <b-form-group>
                      <label for="email_id">Email ID</label>
                      <b-input-group class="mb-3">
                        <b-form-input
                          class="input"
                          type="text"
                          v-model="customer.email_id"
                          name="email_id"
                          id="email_id"
                          v-validate="'required|email'"
                          :class="{
                            input: true,
                            'text-danger': errors.has('form-1.email_id'),
                          }"
                          placeholder="Enter Email ID"
                          disabled
                        >
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span
                          style="width:240px"
                          v-show="errors.has('form-1.email_id')"
                          class="help text-danger"
                          >{{ errors.first("form-1.email_id") }}</span
                        >
                      </b-input-group>
                    </b-form-group>
                  </div>

                  <div class="col-md-6 pull-right" style="margin-top:-16px;">
                    <b-form-group>
                      <label for="role">User Role</label>
                      <b-input-group
                        style="border:1px solid #bfbfbf; padding:6px; background-color: #e4e7ea; color: #69709d;"
                      >
                        <span @click="toggleInfoModal(customer.user_type)">
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '0'"
                            :v-model="customer.role"
                          >
                            <span>Admin</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '1'"
                            :v-model="customer.role"
                          >
                            <span>Brand Manager</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '2'"
                            :v-model="customer.role"
                          >
                            <span>Buyer</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '10'"
                            :v-model="customer.role"
                          >
                            <span>Junior Buyer</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '3'"
                            :v-model="customer.role"
                          >
                            <span>Designer</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '9'"
                            :v-model="customer.role"
                          >
                            <span>Graphics Designer</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '4'"
                            :v-model="customer.role"
                          >
                            <span>Fit Technician</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '5'"
                            :v-model="customer.role"
                          >
                            <span>Design Head</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '6'"
                            :v-model="customer.role"
                          >
                            <span>PO Executive</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '7'"
                            :v-model="customer.role"
                          >
                            <span>Quality Controller</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '8'"
                            :v-model="customer.role"
                          >
                            <span>QC Executive</span>
                          </span>

                           <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '11'"
                            :v-model="customer.role"
                          >
                            <span>Planner Admin</span>
                          </span>

                            <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '12'"
                            :v-model="customer.role"
                          >
                            <span>Planner</span>
                          </span>

                            <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="customer.user_type == '13'"
                            :v-model="customer.role"
                          >
                            <span>Buying Head</span>
                          </span>

                        </span>
                        <b-form-select v-if="this.user_type=='Brand_Manager' && customer.user_type == '14'" v-model="customer.role" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.role') }">
                          <option value="">--Select--</option>
                          <option value="2">Buyer</option>
                          <option value="3">Designer</option>
                          <option value="4">Fit Technician</option>
                          <option value="5">Design Head</option>
                          <option value="6">PO Executive</option>
                        </b-form-select>
                          <b-form-select v-if="this.user_type=='Admin' && customer.user_type == '14'" v-model="customer.role" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.role') }">
                          <option value="">--Select--</option>
                          <option value="1">Brand Manager</option>
                          <option value="7">Quality Controller</option>
                          <option value="11">Planner Admin</option>
                          <option value="13">Buying_Head</option>
                        </b-form-select>
                        <b-form-select v-if="this.user_type=='Buyer' && customer.user_type == '14'" v-model="customer.role" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.role') }">
                          <option value="">--Select--</option>
                          <option value="10">Junior_Buyer</option>
                        </b-form-select>

                        

                        <!-- <b-form-select v-if="this.user_type=='Admin'" v-model="customer.role" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.role') }">
                          <option value="">--Select--</option>
                          <option value="1">Brand Manager</option>
                          
                        </b-form-select> -->
                        <!-- 
                         <b-form-select v-if="this.user_type=='Quality_Head'" v-model="customer.role" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.role') }">
                          <option value="">--Select--</option>
                          <option value="7">Quality Controller</option>
                        </b-form-select> 

                        <b-form-select v-if="this.user_type=='Quality_Controller'" v-model="customer.role" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.role') }">
                          <option value="">--Select--</option>
                          <option value="7">Quality Controller</option>
                        </b-form-select>

                        <b-form-select v-if="this.user_type=='Brand_Manager'" v-model="customer.role" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.role') }" @change="disablebrand(customer.role); displaydesignation(customer.role)">
                          <option value="">--Select--</option>
                          <option value="2">Buyer</option>
                          <option value="3">Designer</option>
                          <option value="4">Fit Technician</option>
                          <option value="5">Design Head</option>
                          <option value="6">PO Executive</option>
                        </b-form-select>
                        
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('role')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.role')" id="statustxt" class="help text-danger">{{ errors.first('form-1.role') }}
                        </code>-->
                      </b-input-group>
                    </b-form-group>
                  </div>

                  

                  <div
                    class="col-md-6 pull-left"
                    v-if="customer.user_type == '8'"
                  >
                    <b-form-group>
                      <label for="city">City</label>
                      <b-input-group class="mb-3">
                        <b-form-input
                          class="input"
                          type="text"
                          v-model="customer.city"
                          name="city"
                          id="city"
                          v-validate="'required'"
                          :class="{
                            input: true,
                            'text-danger': errors.has('form-1.city'),
                          }"
                          placeholder="Enter City"
                          disabled
                        >
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span
                          style="width:240px"
                          v-show="errors.has('form-1.city')"
                          class="help text-danger"
                          >{{ errors.first("form-1.city") }}</span
                        >
                      </b-input-group>
                    </b-form-group>
                  </div>

                  <div
                    class="col-md-6 pull-right mb-5 mt-2"
                    v-if="customer.user_type == '7'"
                  >
                    <label>City</label>
                    <b-form-select
                      v-model="city"
                      id="city"
                      name="city"
                      placeholder="Please Select city"
                    >
                      <option
                        value=""
                        v-if="customer.city != null || customer.city != ''"
                        >{{ customer.city }}</option
                      >

                      <option
                        value="Delhi"
                        v-if="customer.city == 'Delhi'"
                        hidden
                      ></option>
                      <option value="Delhi" v-if="customer.city != 'Delhi'"
                        >Delhi</option
                      >

                      <option
                        value="Ludhiana"
                        v-if="customer.city == 'Ludhiana'"
                        hidden
                      ></option>
                      <option
                        value="Ludhiana"
                        v-if="customer.city != 'Ludhiana'"
                        >Ludhiana</option
                      >
                      <option
                        value="Mumbai"
                        v-if="customer.city == 'Mumbai'"
                        hidden
                      ></option>
                      <option value="Mumbai" v-if="customer.city != 'Mumbai'"
                        >Mumbai</option
                      >
                      <option
                        value="Jaipur"
                        v-if="customer.city == 'Jaipur'"
                        hidden
                      ></option>
                      <option value="Jaipur" v-if="customer.city != 'Jaipur'"
                        >Jaipur</option
                      >
                      <option
                        value="Kolkata"
                        v-if="customer.city == 'Kolkata'"
                        hidden
                      ></option>
                      <option value="Kolkata" v-if="customer.city != 'Kolkata'"
                        >Kolkata</option
                      >
                      <option
                        value="New delhi"
                        v-if="customer.city == 'New delhi'"
                        hidden
                      ></option>
                      <option
                        value="New delhi"
                        v-if="customer.city != 'New delhi'"
                        >New delhi</option
                      >
                      <option
                        value="Tirupur"
                        v-if="customer.city == 'Tirupur'"
                        hidden
                      ></option>
                      <option value="Tirupur" v-if="customer.city != 'Tirupur'"
                        >Tirupur</option
                      >
                      <option
                        value="Bangalore"
                        v-if="customer.city == 'Bangalore'"
                        hidden
                      ></option>
                      <option
                        value="Bangalore"
                        v-if="customer.city != 'Bangalore'"
                        >Bangalore</option
                      >
                      <option
                        value="Lahuri"
                        v-if="customer.city == 'Lahuri'"
                        hidden
                      ></option>
                      <option value="Lahuri" v-if="customer.city != 'Lahuri'"
                        >Lahuri</option
                      >
                    </b-form-select>
                  </div>

                  <!-- 
                   <div class="col-md-6 pull-left">   
                      <b-form-group>
                        <label for="pincode">Status</label>
                        <b-input-group >
                          <b-form-select v-model="customer.isactive" name="status" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.status') }">
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('status')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.status')" id="statustxt" class="help text-danger">{{ errors.first('form-1.status') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </div> -->

                  <div
                    class="col-md-6 pull-left"
                    id="designation_block"
                    style="display: none;"
                    v-if="this.user_type == 'Brand_Manager'"
                  >
                    <b-form-group>
                      <label for="pincode">Designation</label>
                      <b-input-group>
                        <!-- <b-form-input class="input" type="text" v-model="customer.designation" name="designation" id="designation" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.designation') }" placeholder="Enter Designation">
                        </b-form-input> -->
                        <b-form-select
                          v-model="customer.designation"
                          name="designation"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.designation'),
                          }"
                        >
                          <option value="">--Select--</option>
                          <option value="Senior Buyer">Senior Buyer</option>
                          <option value="Junior Buyer">Junior Buyer</option>
                        </b-form-select>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('designation')"
                          ></i>
                        </span>
                        <code
                          v-show="errors.has('form-1.designation')"
                          id="statustxt"
                          class="help text-danger"
                          >{{ errors.first("form-1.designation") }}
                        </code>
                      </b-input-group>
                    </b-form-group>
                  </div>
                  
                  <!-- 
                  <div class="col-md-6 pull-left" v-if="this.user_type=='Brand_Manager'">   
                      <b-form-group>
                        <label for="selectbrand">Select Category</label>
                        <b-input-group class="mb-3">
                          <ejs-multiselect id='multiselect1' placeholder="Select Category" v-model="sel_cat" name="sel_cat" :dataSource='cat_arr' :fields='catagentfields' :showSelectAll='true' :class="{'input': true, 'is-invalid': errors.has('form-5.cat_arr') }">
                         </ejs-multiselect>

                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('cat_arr')" ></i>
                        </span>
                        <span class="icon has-text-warning"
                         v-show="errors.has('form-1.cat_arr')">{{ errors.first('form-1.cat_arr') }}</span>
                        </b-input-group>
                      </b-form-group>
                  </div> -->

                  <!-- <div class="col-md-6 pull-right" v-if="this.user_type=='Admin' || this.user_type=='Brand_Manager'">   
                      <b-form-group>
                        <label for="selectbrand">Select Subcategory</label>
                        <b-input-group class="mb-3">

                          <ejs-multiselect id='multiselect' placeholder="Select Subcategory" v-model="sel_subcat" name="sub_cat_arr":dataSource='sub_cat_arr'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue1'  enableGroupCheckBox="true" mode="CheckBox" :class="{'input': true, 'is-invalid': errors.has('form-5.sub_cat_arr') }">
                    </ejs-multiselect>


                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('sub_cat_arr')" ></i>
                        </span>
                        <span class="icon has-text-warning"
                         v-show="errors.has('form-1.sub_cat_arr')">{{ errors.first('form-1.sub_cat_arr') }}</span>
                        </b-input-group>
                      </b-form-group>
                  </div> -->

                  <!-- <div
                    class="col-md-6 pull-right"
                    v-if="this.user_type == 'Quality_Controller'"
                  >
                    <b-form-group>
                      <label for="selectbrand">Select Vendors</label>
                      <b-input-group class="mb-3">
                        <ejs-multiselect
                          id="multiselect"
                          placeholder="Select Vendors"
                          v-model="selected_vendors"
                          name="selected_vendors"
                          :dataSource="vendor_list_arr"
                          :showSelectAll="showSelectAll"
                          selectAllText="Select All"
                          unSelectAllText="unSelect All"
                          :fields="vendorfields"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-5.vendor_list_arr'),
                          }"
                        >
                        </ejs-multiselect>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('selected_vendors')"
                          ></i>
                        </span>
                        <span
                          class="icon has-text-warning"
                          v-show="errors.has('form-1.selected_vendors')"
                          >{{ errors.first("form-1.selected_vendors") }}</span
                        >
                      </b-input-group>
                    </b-form-group>
                  </div> -->

                   <div class="col-md-6 pull-right m-0">
                    <b-form-group>
                      <label for="first name">New Password</label>
                      <b-form-input
                        type="text"
                        name="newpassword"
                        v-model="newpassword"
                        :disabled="isPasswordverified == false"
                        placeholder="Enter New Password"
                      >
                      </b-form-input>
                      <b-input-group>
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('full_name')"
                          ></i>
                        </span>
                        <span
                          style="width:240px"
                          v-show="errors.has('form-1.full_name')"
                          class="help text-danger"
                          >{{ errors.first("form-1.full_name") }}</span
                        >
                      </b-input-group>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 pull-right" style="margin-top:-30px;">
                    <b-form-group>
                      <label for="contact_no">Change Password</label>
                      <b-input-group>
                        <b-form-input
                          class="input"
                          type="text"
                          id="oldpassword"
                          name="oldpassword"
                          v-model="oldpassword"
                          :disabled="isPasswordverified == true"
                          placeholder="Enter Old Password"
                        >
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('contact_no')"
                          ></i>
                        </span>
                        <code
                          v-show="errors.has('form-1.contact_no')"
                          id="addmblnbrmsg"
                          class="help text-danger"
                          >{{ errors.first("form-1.contact_no") }}
                        </code>
                        
                      </b-input-group>
                      <buttion type="button" class="btn btn-primary m-0 p-1" @click="verifyUserPassword(customer.user_id);" :hidden="isPasswordverified == true" >Verify Password</buttion>
                      <!-- <span class="m-0" type="button" variant="secondary" style="cursor: pointer;" @click="verifyUserPassword(customer.user_id);" :hidden="isPasswordverified == true"><b>Verify Password</b></span> -->
                      
                    </b-form-group>
                  </div>

                  <div class="col-md-12 pull-right">
                    <footer class="column has-text-right pull-right">
                      <b-button variant="primary" size="md" type="submit" @click="updatemanageruser();"
                        >Submit</b-button
                      >&nbsp;
                      <b-button
                        variant="secondary"
                        size="md"
                        type="submit"
                        @click="cancelbtn()"
                        >Cancel</b-button
                      >
                    </footer>
                  </div>
                <!-- </b-form> -->
              </b-card-body>
            </b-col>
          </b-row>
          <br />
          <b-row
            class="p-2"
            style="border:1px solid	#D3D3D3;"
            v-if="
              this.customer.user_type != 7 && user_type != 'Quality_Controller' && user_type != 'Planner_Admin' && this.customer.user_type != 11 
            "
          >
            <button class="btn btn-success m-2" v-b-modal.modal-1>
              Assign
            </button>

            <b-table
              class="mt-4"
              show-empty
              stacked="md"
              :items="getassign_list"
              :fields="fields1"
              :bordered="bordered"
            >
              <template slot="editbtn" slot-scope="row">
                <button
                  class="btn"
                  v-b-modal.modal-x
                  @click="
                    showEditModal(
                      row.item.id,
                      row.item.category_name,
                      row.item.brand_name,
                      row.item.brand_id,
                      row.item.cat_id,
                      row.item.subcat_name,
                      row.item.sub_category
                    )
                  "
                >
                  Edit
                </button>
              </template>

              <template slot="deletebtn" slot-scope="row">
                <button
                  class="btn"
                  v-b-modal.modal-delete
                  @click="showDeleteModal(row.item.id)"
                >
                  Delete
                </button>
              </template>
              <template
                slot="category_nametab"
                slot-scope="row"
                v-if="
                  row.item.category_name != '' || row.item.category_name != null
                "
              >
                <span v-for="data in row.item.category_name"> {{ data }},</span>
              </template>

              <template
                slot="subcat_nametab"
                slot-scope="row"
                v-if="
                  row.item.subcat_name != '' || row.item.subcat_name != null
                "
              >
                <span v-for="data1 in row.item.subcat_name"> {{ data1 }},</span>
              </template>

              <template
                slot="brand_nametab"
                slot-scope="row"
                v-if="
                  row.item.category_name != '' || row.item.category_name != null
                "
              >
                <span v-for="data2 in row.item.brand_name">{{ data2 }}</span>
              </template>
            </b-table>

            <!-- <b-col class="col-md-12 mb-3">
        <b-button variant="success" size="md" type="submit">Submit</b-button>
       </b-col> -->
            <!-- <table class="table table-bordered">
            <thead>
              <tr>
              <th>Category name</th>
              <th>Sub Category name</th>
              <th>Brand name</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
            </thead>
            <tbody>
              <tr>
                <td>Category name</td>
                <td>Subcat name</td>
                <td>brand name</td>
                <td><button class="btn btn-primary" v-b-modal.modal-x @click="showEditModal();">Edit</button></td>
                <td><button class="btn btn-danger" v-b-modal.modal-delete @click="showDeleteModal();">Delete</button></td>
            </tr>
            </tbody>
          </table> -->
          </b-row>
        </div>
      </div>

      <!-- ~~~~~~~~~~~Modal for show Edit-->
      <b-modal
        title="Edit Data"
        id="modal-x"
        v-model="isEditModelVisible"
        @ok="isEditModelVisible = false"
      >
        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm3('form-2')"
            data-vv-scope="form-2"
          >
            <div v-if="disable_brand != true">
              <b-card no-body>
                <!-- <b-form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2"> -->
                <b-form-group>
                  <label for="selectbrand" v-if="customer.role != 7"
                    >Brand Name:</label
                  >

                  <b-form-input
                    type="text"
                    name="selected_brandID"
                    v-model="selected_brandname"
                    disabled
                  >
                  </b-form-input>
                  <!-- <label for="selectbrand" v-if="customer.role!=7">Select Brand</label>

               <b-input-group class="mb-3"  id="brand_block"> 
               
                 <ejs-multiselect id='multiselect' placeholder="Select Brand" v-model="brand_id" name="assigned_brand" :dataSource='brandrecord'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"  :fields='brandfields' :class="{'input': true, 'is-invalid': errors.has('form-2.assigned_brand') } " >
                 </ejs-multiselect>
               </b-input-group> 

             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
               <i class="fa fa-warning" v-show="errors.has('assigned_brand')" ></i>
             </span>
             <span class="icon has-text-warning"
               v-show="errors.has('form-2.assigned_brand')">{{ errors.first('form-2.assigned_brand') }}</span>
             </b-input-group> -->

                  <b-input-group
                    class="mb-3"
                    v-if="user_type == 'Quality_Controller'"
                  >
                    <b-form-select
                      v-model="brand_id"
                      id="brand_id"
                      name="brand_id"
                      placeholder="Please Select Brand."
                    >
                      <option :value="selected">--Select--</option>
                      <option
                        :value="brand_list.brand_id"
                        v-for="brand_list in assigned_brand"
                        >{{ brand_list.brand_title }}</option
                      >
                    </b-form-select>
                  </b-input-group>

                  <!-- <b-input-group class="mb-3" v-if="this.user_type=='Admin' && customer.role!=7">
             <b-form-select v-model="brand_id" id="brand_id" name="brand_id" placeholder="Please Select Brand.">
                     <option :value="selected"  >--Select--</option>
                     <option  :value="brand_list.brand_id" v-for="brand_list in brandrecord">{{ brand_list.brand_title }}</option>
             </b-form-select> 
             </b-input-group>

             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
               <i class="fa fa-warning" v-show="errors.has('options')" ></i>
             </span>
             <span class="icon has-text-warning"
               v-show="errors.has('form-1.options')">{{ errors.first('form-1.options') }}</span>
             </b-input-group> -->
                </b-form-group>

                <div
                  class="col-md-6 pull-left"
                  id="designation_block"
                  style="display: none;"
                >
                  <b-form-group>
                    <label for="pincode">Designation</label>
                    <b-input-group>
                      <!-- <b-form-input class="input" type="text" v-model="customer.designation" name="designation" id="designation" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.designation') }" placeholder="Enter Designation">
                     </b-form-input> -->
                      <b-form-select
                        v-model="customer.designation"
                        name="designation"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-2.designation'),
                        }"
                      >
                        <option value="">--Select--</option>
                        <option value="Senior Buyer">Senior Buyer</option>
                        <option value="Junior Buyer">Junior Buyer</option>
                      </b-form-select>
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i
                          class="fa fa-warning"
                          v-show="errors.has('designation')"
                        ></i>
                      </span>
                      <code
                        v-show="errors.has('form-2.designation')"
                        id="statustxt"
                        class="help text-danger"
                        >{{ errors.first("form-2.designation") }}
                      </code>
                    </b-input-group>
                  </b-form-group>
                </div>

                <b-form-group>
                  <label for="selectbrand">Category Name</label>

                  <b-form-input
                    type="text"
                    name="selected_catID"
                    v-model="selected_catname"
                    disabled
                  >
                  </b-form-input>
                  <!-- <label for="selectbrand">Select Category</label>
               <b-input-group class="mb-3">

                 <ejs-multiselect id='multiselect' placeholder="Select Category" v-model="selected_cat_id" name="selected_cat_id" :dataSource='cat_arr' @change="getSubcatlist(selected_cat_id)" :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='catagentfields' :class="{'input': true, 'is-invalid': errors.has('form-2.selected_cat_id') }" >
           </ejs-multiselect> -->

                  <!-- @select="getSubCategoryList($event,selected_cat_id)" -->
                  <!-- </b-input-group>
               <b-input-group class="mb-3">
                 <span class="icon has-text-warning">
                 <i class="fa fa-warning" v-show="errors.has('selected_cat_id')" ></i>
               </span>
               <span class="icon has-text-warning"
                 v-show="errors.has('form-2.selected_cat_id')">{{ errors.first('form-2.selected_cat_id') }}</span>
               </b-input-group> -->
                </b-form-group>

                <b-form-group id="subcat_block">
                  <label for="selectbrand">Select Subcategory</label>
                  &emsp; Check All&nbsp;<input type="checkbox" id="checkbox1" @click="(e) => selectAllSubCatForEdit(e.target.checked)">
                  
                  <b-input-group class="mb-3">
                    <ejs-multiselect
                      id="multiselect"
                      placeholder="Select Subcategory"
                      v-model="sel_subcat2"
                      name="sel_subcat2"
                      :dataSource="data_source2"
                      :showSelectAll="showSelectAll1"
                      selectAllText="Select All"
                      unSelectAllText="unSelect All"
                      :fields="agentfields"
                      @change="selectval1"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-2.sel_subcat2'),
                      }"
                    >
                    </ejs-multiselect>
                    <!-- {{ sel_subcat2 }} -->
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('sel_subcat2')"
                      ></i>
                    </span>
                    <span
                      class="icon has-text-warning"
                      v-show="errors.has('form-2.sel_subcat2')"
                      >{{ errors.first("form-2.sel_subcat2") }}</span
                    >
                  </b-input-group>
                </b-form-group>

                <div class="col-md-12 pull-right">
                  <footer class="column has-text-right pull-right">
                    <b-button variant="primary" size="md" type="submit"
                      >Submit</b-button
                    >&nbsp;
                    <b-button
                      variant="secondary"
                      size="md"
                      type="button"
                      @click="cancelassignmodal()"
                      >Cancel</b-button
                    >
                  </footer>
                </div>
              </b-card>
            </div>
          </b-form>
        </template>
      </b-modal>

      <!-- ~~~~~~~~~~~~~~Modal end for Edit -->

      <!-- ~~~~~~~~~~~Modal for show Delete-->
      <b-modal
        title="Delete Data"
        id="modal-delete"
        v-model="isDeleteModelVisible"
        @ok="isDeleteModelVisible = false"
      >
        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm4('form-4')"
            data-vv-scope="form-2"
          >
            <div v-if="disable_brand != true">
              <b-card no-body>
                <p>Are you sure want to delete?</p>
                <!-- {{this.deleteId}} -->

                <div class="col-md-12 pull-right">
                  <footer class="column has-text-right pull-right">
                    <b-button variant="primary" size="md" type="submit"
                      >Delete</b-button
                    >&nbsp;
                    <b-button
                      variant="secondary"
                      size="md"
                      type="button"
                      @click="cancelassignmodalD()"
                      >Cancel</b-button
                    >
                  </footer>
                </div>
              </b-card>
            </div>
          </b-form>
        </template>
      </b-modal>

      <!-- ~~~~~~~~~~~~~~Modal end for Delete -->

      <!-- ~~~~~~~~~~~Modal for show Assign modal-->
      <b-modal
        title="Assign Category, Sub-category and Brand to user"
        id="modal-1"
        v-model="assign_category"
        @ok="assign_category = false"
      >
        <!-- <template slot="header" slot-scope="{ hide }">
         
          <b-button variant="danger" @click="editcancel()"
            ><i class="fa fa-times"></i
          ></b-button>
      
        </template> -->

        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm2('form-2')"
            data-vv-scope="form-2"
            id="assignform"
          >
            <div v-if="disable_brand != true">
              <b-card no-body>
                <!-- <b-form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2"> -->
                <b-form-group>
                  <label for="selectbrand" v-if="customer.role != 7"
                    >Select Brand</label
                  >

                  <!-- <b-input-group class="mb-3"  id="brand_block"> 
               
                 <ejs-multiselect id='multiselect' placeholder="Select Brand" v-model="brand_id" name="assigned_brand" :dataSource='brandrecord'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"  :fields='brandfields' :class="{'input': true, 'is-invalid': errors.has('form-2.assigned_brand') } " >
                 </ejs-multiselect>
               </b-input-group> 

             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
               <i class="fa fa-warning" v-show="errors.has('assigned_brand')" ></i>
             </span>
             <span class="icon has-text-warning"
               v-show="errors.has('form-2.assigned_brand')">{{ errors.first('form-2.assigned_brand') }}</span>
             </b-input-group> -->

                  <b-input-group
                    class="mb-3"
                    v-if="disable_brand != true"
                    id="brand_block"
                  >
                    <b-form-select
                      v-model="brand_id"
                      id="brand_id"
                      name="assigned_brand"
                      placeholder="Please Select Brand."
                      @change='selectCategory(brand_id)'>
                      <option :value="selected">--Select--</option>
                      <option
                        :value="brand_list.brand_id"
                        v-for="brand_list in brandrecord"
                        >{{ brand_list.brand_title }}</option
                      >
                    </b-form-select>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('options')"
                      ></i>
                    </span>
                    <span
                      class="icon has-text-warning"
                      v-show="errors.has('form-1.options')"
                      >{{ errors.first("form-1.options") }}</span
                    >
                  </b-input-group>

                  <b-input-group
                    class="mb-3"
                    v-if="user_type == 'Quality_Controller'"
                  >
                    <b-form-select
                      v-model="brand_id"
                      id="brand_id"
                      name="brand_id"
                      placeholder="Please Select Brand."
                    >
                      <option :value="selected">--Select--</option>
                      <option
                        :value="brand_list.brand_id"
                        v-for="brand_list in assigned_brand"
                        >{{ brand_list.brand_title }}</option
                      >
                    </b-form-select>
                  </b-input-group>

                  <!-- <b-input-group class="mb-3" v-if="this.user_type=='Admin' && customer.role!=7">
             <b-form-select v-model="brand_id" id="brand_id" name="brand_id" placeholder="Please Select Brand.">
                     <option :value="selected"  >--Select--</option>
                     <option  :value="brand_list.brand_id" v-for="brand_list in brandrecord">{{ brand_list.brand_title }}</option>
             </b-form-select> 
             </b-input-group>

             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
               <i class="fa fa-warning" v-show="errors.has('options')" ></i>
             </span>
             <span class="icon has-text-warning"
               v-show="errors.has('form-1.options')">{{ errors.first('form-1.options') }}</span>
             </b-input-group> -->
                </b-form-group>

                <div
                  class="col-md-6 pull-left"
                  id="designation_block"
                  style="display: none;"
                >
                  <b-form-group>
                    <label for="pincode">Designation</label>
                    <b-input-group>
                      <!-- <b-form-input class="input" type="text" v-model="customer.designation" name="designation" id="designation" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.designation') }" placeholder="Enter Designation">
                     </b-form-input> -->
                      <b-form-select
                        v-model="customer.designation"
                        name="designation"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-2.designation'),
                        }"
                      >
                        <option value="">--Select--</option>
                        <option value="Senior Buyer">Senior Buyer</option>
                        <option value="Junior Buyer">Junior Buyer</option>
                      </b-form-select>
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i
                          class="fa fa-warning"
                          v-show="errors.has('designation')"
                        ></i>
                      </span>
                      <code
                        v-show="errors.has('form-2.designation')"
                        id="statustxt"
                        class="help text-danger"
                        >{{ errors.first("form-2.designation") }}
                      </code>
                    </b-input-group>
                  </b-form-group>
                </div>

                <b-form-group>
                  <label for="selectbrand">Select Category</label>

                  <b-input-group
                    class="mb-3"
                    v-if="disable_brand != true"
                    id="brand_block"
                  >
                    <b-form-select
                      v-model="selected_cat_id"
                      id="multiselect"
                      name="selected_cat_id"
                      placeholder="Please Select Brand."
                      @change="selectSubCategory(selected_cat_id,brand_id)"
                    >
                      <option :value="selected">--Select--</option>
                      <option
                        :value="cat_list.category_id"
                        v-for="cat_list in cat_arr"
                        >{{ cat_list.category_title }}</option
                      >
                    </b-form-select>
                  </b-input-group>

                  <!-- 
               <b-input-group class="mb-3">

                 <ejs-multiselect id='multiselect' placeholder="Select Category" v-model="selected_cat_id" name="selected_cat_id" :dataSource='cat_arr' @change="getSubcatlist(selected_cat_id)" :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='catagentfields' :class="{'input': true, 'is-invalid': errors.has('form-2.selected_cat_id') }" >
           </ejs-multiselect>


               </b-input-group> -->
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('selected_cat_id')"
                      ></i>
                    </span>
                    <span
                      class="icon has-text-warning"
                      v-show="errors.has('form-2.selected_cat_id')"
                      >{{ errors.first("form-2.selected_cat_id") }}</span
                    >
                  </b-input-group>
                </b-form-group>

                <b-form-group id="subcat_block"> 
                  <label for="selectbrand">Select Subcategory</label>
                   &emsp; Check All&nbsp;<input type="checkbox" id="checkbox" :disabled="!selectedCategories" @click="(e) => selectAllSubCat(e.target.checked)">
                  <b-input-group class="mb-3">
                    <ejs-multiselect
                      id="multiselect"
                      placeholder="Select Subcategory"
                      v-model="sel_subcat"
                      name="sel_subcat"
                      :dataSource="sub_cat_arr"
                      :showSelectAll="showSelectAll"
                      selectAllText="Select All"
                      unSelectAllText="unSelect All"
                      :fields="agentfields"
                      @change="selectval"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-2.sel_subcat'),
                      }"
                    >
                    </ejs-multiselect> 
                    
                  </b-input-group> 
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('sel_subcat')"
                      ></i>
                    </span>
                    <span
                      class="icon has-text-warning"
                      v-show="errors.has('form-2.sel_subcat')"
                      >{{ errors.first("form-2.sel_subcat") }}</span
                    >
                  </b-input-group>
                </b-form-group>

                <div class="col-md-12 pull-right">
                  <footer class="column has-text-right pull-right">
                    <b-button variant="primary" size="md" type="submit"
                      >Submit</b-button
                    >&nbsp;
                    <b-button
                      variant="secondary"
                      size="md"
                      type="button"
                      @click="editcancel()"
                      >Cancel</b-button
                    >
                  </footer>
                </div>
              </b-card>
            </div>
          </b-form>
        </template>
      </b-modal>
      <!-- ~~~~~~~~~~~~~~Modal end for Assign -->
    </b-row>
  </div>
</template>
<style>
.scroll {
  width: 200px;
  height: 100px;
  overflow: scroll;
}
</style>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import Router from "vue-router";
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";
import ButtonGroups from "../views/buttons/ButtonGroups.vue";

const axios = require("axios");
export default {
  components: {
    sidebarSettingsComponent,
    ButtonGroups,
  },

  data: function() {
    return {
      name: "reattemptshipment",
      customer: {},
      selected: "selected",
      deliveryagentfirstname: "",
      brandrecord: [],
      city: "",
      options: [],
      agentfields: { text: "sub_cattitle", value: "sub_catid" },
      catagentfields: { text: "category_title", value: "category_id" },
      showSelectAll: true,
      showSelectAll1: true,
      allowCustomValue: true,
      allowCustomValue1: true,
      user_type: "",
      sel_brand: [],
      myArray: [],
      cat_name_arr: [],
      brand_name_arr: [],
      disable_brand: false,
      sub_cat_arr: [],
      sub_cat_arr1: [],
      edit_subcat_modal: [],
      cat_arr: [],
      sel_subcat: [],
      data_source2: [],
      sel_subcat2: [],
      sel_cat: [],
      sortDesc: true,
      sortDirection: "desc",
      perPage: 10,
      currentPage: 1,
      sortBy: null,
      filter: null,
      bordered: true,
      isBusy: false,
      isEditModelVisible: false,
      isDeleteModelVisible: false,
      assign_category: false,
      brandfields: { text: "brand_title", value: "brand_id" },
      brand_id: [],
      selected_cat_id: [],
      assigned_data: [],
      selected_vendors: [],
      getassign_list: [],
      deleteId: "",
      editId: "",
      get_cat_id: "",
      selected_catname: "",
      selected_brandname: "",
      selected_brandID: "",
      selected_catID: [],
      assign_brand_data: [],
      selected_cat_id_arr: [],
      selected_subcat_name: [],
      tempArr: [],
      vendorfields: { text: "vendor_name", value: "vendor_id" },
      vendor_list_arr: [],
      // items:[],
      fields1: [
        { key: "brand_nametab", label: "Brand Name" },
        { key: "category_nametab", label: "Category Name" },
        { key: "subcat_nametab", label: "Sub-Category Name" },
        { key: "editbtn", label: "Edit" },
        { key: "deletebtn", label: "Delete" },
      ],
      oldpassword:"",
      isPasswordverified: false,
      newpassword:"",
      iscategoryselected: false,
      iscategoryselectedforedit: false,
      selectedsubcatarry:[],
      selectedCategoryID:'',
      user_id:'',
      selectedCategories:''
    };
  },
  created: function() {
    this.getUserDetails(this.$route.params.id);
    this.getSubCategoryList();
    this.getassigncatsubctidlist();
    this.getvendorlist();
    this.getCategoryList();
    var userData = localStorage.getItem("userData");
    if (userData) {
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      this.user_id = userInfo[0].user_id;

      // this.brandlisting();
      this.getAllocateddBrandList()
    }
  },

  watch :{

    sel_subcat:{    
      handler(newValue, oldValue) {
        console.log("OK")
        if(this.sel_subcat.length == this.sub_cat_arr.length){
            this.iscategoryselected = true;
          // console.log("Watcher")
          // console.log(this.sel_subcat.length)
          // console.log(this.iscategoryselected )
        }else{
          this.iscategoryselected = false;
        }
          
      }

    }

  },


  methods: {
    displaydesignation(value) {
      // document.getElementById("designation_block").style.display="block";
      if (value == 2) {
        document.getElementById("designation_block").style.display = "block";
      } else {
        document.getElementById("designation_block").style.display = "none";
      }
    },
    getUserDetails: function(value) {
      const Obj = {
        user_id: value,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getUserDetails`, Obj)
        .then((response) => {
          //document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.customer = this.result.returnvalue[0];
            // this.customer.full_name=
            // this.customer.contact_no=
            // this.customer.email_id=
            // this.customer.role=
            // this.customer.role=
            // this.customer.isactive=
            // this.customer.designation=
            // this.sel_cat=
            // this.sel_subcat=
            this.totalRows = this.result.returnvalue.length;
          } else {
            this.customer = [];
            this.totalRows = 0;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getvendorlist: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);

      this.isBusy = true;

      axios
        .post(`${CONSTANTS.API_URL}/getvendorlist`, {})
        .then((response) => {
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.vendor_list_arr = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.vendor_list_arr = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get Sub Category List********/
    getCategoryList: function(value) {
      axios
        .post(`${CONSTANTS.API_URL}/categoryList`, {})
        .then((response) => {
          //document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.cat_arr = this.result.returnvalue;
            for (var j = 0; j <= this.cat_arr.length; j++) {
              this.cat_name_arr.push(this.cat_arr[j].category_title);
            }

            this.totalRows = this.result.returnvalue.length;
          } else {
            this.cat_arr = [];
            this.totalRows = 0;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get Sub Category List********/
    getSubCategoryList: function(value) {
      let catid_arr = [];
      catid_arr.push(value);
      const Obj = {
        cat_id: catid_arr,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getSubCategoryList`, Obj)
        .then((response) => {
          //document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.sub_cat_arr = this.result.returnvalue;

  
            // var data = [];

            // this.sub_cat_arr.forEach(function(srData) {
            //   data.push({
            //     key: srData.sub_catid,
            //     label: srData.sub_cattitle,
            //   });
            // });
            // console.log("OOOOOOOOOOOOOOOOOOOOOO", data);
            // this.sub_cat_arr = data;

            this.edit_subcat_modal = [];
            this.totalRows = this.result.returnvalue.length;
          } else {
            this.sub_cat_arr = [];
            this.totalRows = 0;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    // validateForm(scope) {
    //   this.$validator.validateAll(scope).then((result) => {
    //     if (result) {
    //       var userData = localStorage.getItem("userData");
    //       var userInfo = JSON.parse(userData);
    //       this.updatemanageruser();
    //       //   if(userInfo[0].user_type=='Fit_Technician' || userInfo[0].user_type=='Admin'){
    //       //   this.addAgentInfo();
    //       // }
    //       // else if(userInfo[0].user_type=='Brand_Manager'){
    //       //     this.updatemanageruser();

    //       // }
    //     }
    //   });
    // },

    validateFormassign(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var userData = localStorage.getItem("userData");
          var userInfo = JSON.parse(userData);
          if (
            userInfo[0].user_type == "Fit_Technician" ||
            userInfo[0].user_type == "Admin"
          ) {
            this.addCatSubcatBrand();
          }
        }
      });
    },

    chkmobileVal() {
      var chkValidate = true;
      // var chknumb = /^[0789]{1}\d{9}$/;
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

      var mobilenumber = document.getElementById("contact_no").value;
      if (
        mobilenumber.trim() === "0000000000" ||
        mobilenumber.trim().length < 10
      ) {
        chkValidate = false;
        return false;
      } else if (
        mobilenumber.trim() != "" &&
        !mobilenumber.trim().match(chknumb)
      ) {
        chkValidate = false;
        return false;
      }
      return (chkValidate = chkValidate);
    },

    //disable brand function
    disablebrand: function(value) {
      if (value == 4) {
        this.disable_brand = true;
      } else {
        this.disable_brand = false;
      }
    },
    //Code for update user details for brand manager
    // Add New User
    updatemanageruser: function() {
      document.getElementById("overlay").style.display = "block";
      var chkmobileVal = this.chkmobileVal();
      var assign_brand = [];
      assign_brand.push(this.brand_id);
      let arr = [];
      var assign_cat_id = [];
      assign_cat_id.push(this.sel_subcat);
      var assign_selected_cat_id = [];
      assign_selected_cat_id.push(this.sel_cat);
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      if (chkmobileVal) {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // var usertype='0';
        this.login_user_id = userInfo[0].user_id;
        if (this.customer.usertype) {
          usertype = this.customer.usertype;
        }

        const Obj = {
          full_name: this.customer.full_name,
          contact_no: this.customer.contact_no,
          // user_type: this.customer.user_type,
          created_by: userInfo[0].user_id,
          brand_manager: userInfo[0].user_id,
          currentUserID:this.customer.user_id,
          user_id: this.login_user_id,
          // designation : this.customer.designation,
          // sub_catid: this.sel_subcat,
          // cat_id: this.sel_cat
          city: this.city,
          new_password: this.newpassword,
        };
        if(this.customer.user_type != '14'){
          Obj.user_type =  this.customer.user_type;
        }else{
          Obj.user_type =  this.customer.role;
        }

        axios
          .post(`${CONSTANTS.API_URL}/updateUserDetails`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // Utils.notify("Added successfully", "success");
              this.$fire({
                text: "Data Updated Successfully",
                type: "success",
                timer: 30000,
              });
              this.customer = {};

              this.$router.push("/usersdetails");
            } else {
              // Utils.notify(this.result.returnvalue, "error");
              this.$fire({
                text: this.result.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else {
        // Utils.notify("Please enter valid mobile number", "error");
        this.$fire({
          text: "Please Enter Valid Mobile Number",
          type: "error",
          timer: 30000,
        });
      }
    },

    // Assign category, subcat and brand
    addCatSubcatBrand: function() {
      document.getElementById("overlay").style.display = "block";
      this.isEditModelVisible = !this.isEditModelVisible;
    },

    //Code for update user details for brand manager ends
    // Add New User
    addAgentInfo: function() {
      document.getElementById("overlay").style.display = "block";
      var chkmobileVal = this.chkmobileVal();
      var assign_brand = [];
      // assign_brand=this.brand_id;
      assign_brand.push(this.brand_id);
      let arr = [];
      var assign_cat_id = [];
      assign_cat_id.push(this.sel_subcat);
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      if (chkmobileVal) {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // var usertype='0';
        this.login_user_id = userInfo[0].user_id;
        if (this.customer.usertype) {
          usertype = this.customer.usertype;
        }
        if (userInfo[0].user_type == "Fit_Technician") {
          assign_brand = "";
        }

        const Obj = {
          full_name: this.customer.full_name,
          email_id: this.customer.email_id,
          contact_no: this.customer.contact_no,
          //password: 12345,
          is_active: this.customer.isactive,
          user_type: this.customer.role,
          // brands : assign_brand,
          created_by: userInfo[0].user_id,
          role: this.user_type,
          brand_manager: userInfo[0].user_id,
          designation: this.customer.designation,
          // sub_catid: assign_cat_id
        };
        axios
          .post(`${CONSTANTS.API_URL}/addusersdetails`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // Utils.notify("Added successfully", "success");
              this.$fire({
                text: "Added Successfully",
                type: "success",
                timer: 30000,
              });
              this.customer = {};

              this.$router.push("/usersdetails");
            } else {
              // Utils.notify(this.result.returnvalue, "error");
              this.$fire({
                text: this.result.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else {
        // Utils.notify("Please enter valid mobile number", "error");
        this.$fire({
          text: "Please Enter Valid Mobile Number",
          type: "error",
          timer: 30000,
        });
      }
    },

    //brandlisting
    brandlisting: function() {
      this.isBusy = true;
      axios
        .post(`${CONSTANTS.API_URL}/brandlistingForUser`, {})
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.brandrecord = this.result.returnvalue;
          } else {
            this.brandrecord = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getAllocateddBrandList: function(){
      let userData = localStorage.getItem('userData') ? localStorage.getItem('userData') : ''
      let userInfo = userData ? JSON.parse(userData) : '';
      let user_id = userInfo ? userInfo[0].user_id : ''
      axios.post(`${CONSTANTS.API_URL}/getAllocateddBrandList`,{'user_id':user_id})
      .then(brandListResult=>{
        if(brandListResult.data.returnmsg == 'Successful'){
          this.brandrecord = brandListResult.data.returnvalue
        }else{
          this.brandrecord = []
          this.$fire({
            text: "Brand Data Not Found!",
            type: "warning",
            timer: 30000,
          });
        }
      })
      .catch(brandListingError=>{
        console.log('brandListingError----------->',brandListingError)
          this.brandrecord = []
          this.$fire({
            text: "Error in Getting Brand Data!",
            type: "error",
            timer: 30000,
          });
      })
    },

    getassigncatsubctidlist: function() {
      this.isBusy = true;

      var userData = localStorage.getItem("userData");
      // if (userData) {

      var userInfo = JSON.parse(userData);
      this.user_id = userInfo[0].user_id;
      this.brand_assign = userInfo[0].brand_assign;

      var Obj = {
        user_id: this.user_id,
        currentUserID: this.$route.params.id,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getassigncatsubctidlist`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.getassign_list = this.result.returnvalue;

            this.get_cat_id = this.result.returnvalue[0].cat_id;
            console.log(
              this.result.returnvalue[0].sub_category,
              "this.result.returnvalue;"
            );
          } else {
            this.getassign_list = [];
          }
        });
    },

    // getUserAssignedBrandList
    getUserAssignedBrandList: function() {
      this.isBusy = true;

      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;

        var Obj = {
          user_id: this.user_id,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getUserAssignedBrandList`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              this.brandrecord = this.result.returnvalue;
              for (var j = 0; j <= this.brandrecord.length; j++) {
                this.brand_name_arr.push(this.brandrecord[j].brand_title);
              }
            } else {
              this.brandrecord = [];
              this.totalRows = 0;
              this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      }
    },

    getSubcatlist: function(cat_id) {
      // alert(cat_id);
      this.selectedCategoryID = cat_id
      console.log(cat_id, this.iscategoryselected)
      if(cat_id){
        this.iscategoryselected = true;
        console.log("777777777777777",cat_id, this.iscategoryselected)
      }
      if(cat_id == 'selected'){
        this.iscategoryselected = false;
      }
      this.getSubCategoryList(cat_id);
    },

    getSubcat_editData: function(catid) {
      this.getSubCat_edit_data(catid);
    },

    getSubCat_edit_data: function(value) {
      let catid_arr = [];
      catid_arr.push(value);
      const Obj = {
        cat_id: catid_arr,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getSubCategoryList`, Obj)
        .then((response) => {
          //document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.data_source2 = this.result.returnvalue;
          } else {
            this.edit_subcat_modal = [];
            this.totalRows = 0;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    editcancel: function() {
      // alert(this.selectedCategoryID)
      this.selectedCategoryID =''
      this.brand_id = [];
      this.sel_subcat = [];
      this.selected_cat_id = [];
      this.sub_cat_arr1 = [];
      this.iscategoryselected = false;
      this.assign_category = !this.assign_category;
    },

    cancelassignmodal: function() {
      this.brand_id = [];
      // this.sel_subcat = [];
      this.selected_cat_id = [];
       this.sel_subcat2 = [];
      this.sub_cat_arr_edited = [];
      this.isEditModelVisible = !this.isEditModelVisible;
    },

    cancelassignmodalD: function() {
      this.brand_id = [];
      this.sel_subcat = [];
      this.selected_cat_id = [];
      this.isDeleteModelVisible = !this.isDeleteModelVisible;
    },

    validateForm2(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (this.selected_cat_id.length == 0) {
            this.$fire({
              text: "Please Select Category Name",
              type: "warning",
              timer: 30000,
            });
          } else if (this.sel_subcat.length == 0) {
            // alert("Please Select Subcategory");
            this.$fire({
              text: "Please Select Subcategory",
              type: "warning",
              timer: 30000,
            });
          } else if (this.brand_id == 0) {
            // alert("Please Select Atleast One Brand");
            this.$fire({
              text: "Please Select Atleast One Brand",
              type: "warning",
              timer: 30000,
            });
          } else if (this.brand_id == 0) {
            // alert("Please Select Atleast One Brand");
            this.$fire({
              text: "Please Select Atleast One Brand",
              type: "warning",
              timer: 30000,
            });
          } else if (
            this.user_type == "Admin" ||
            this.user_type == "Brand_Manager" ||
            this.user_type == "Quality_Controller" ||
            this.user_type == "Buyer"

          ) {
            this.assignCatSubBrd();
          }
        }
      });
    },

    assignCatSubBrd: function() {
       document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;

      this.assign_brand_data.push(this.brand_id);
      this.selected_cat_id_arr.push(this.selected_cat_id);

      if (this.user_type == "Admin") {
        var Obj = {
          brands: this.assign_brand_data,
          sub_catid: this.sel_subcat,
          cat_id: this.selected_cat_id_arr,
          currentUserID: this.$route.params.id,
          brand_manager: userInfo[0].user_id,
          user_type: 1,
          selected_vendors: this.selected_vendors,
          created_by: userInfo[0].user_id,
          user_id:userInfo[0].user_id
        };
      } else {
        var Obj = {
          brands: this.assign_brand_data,
          sub_catid: this.sel_subcat,
          cat_id: this.selected_cat_id_arr,
          user_id: userInfo[0].user_id,
          brand_manager: userInfo[0].brand_manager,
          selected_vendors: this.selected_vendors,
          created_by: userInfo[0].user_id,
          currentUserID:this.$route.params.id
          
        };
      }

      axios
        .post(`${CONSTANTS.API_URL}/assigncatsubctid`, Obj)
        .then((response) => {
           document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.assigned_data = this.result.returnvalue;
            
            this.$fire({
              text: "Data added successfully",
              type: "success",
              timer: 30000,
            });
           this.brand_id = [];
            this.sel_subcat = [];
            this.selected_cat_id = [];
            this.assign_brand_data = [];
            this.selected_cat_id_arr = [];

            this.assign_category = !this.assign_category;
            this.getassigncatsubctidlist();
          } else {
            this.$fire({
              text: this.result.returnmsg,
              type: "error",
              timer: 30000,
            });

            this.selected_cat_id = [];
             this.brand_id = [];
              this.sel_subcat = [];
            this.assign_brand_data = [];
            this.selected_cat_id_arr = [];
            this.assigned_data = [];
            this.assign_category = !this.assign_category;
            this.getassigncatsubctidlist();
          }
        });
    },

    validateForm3(scope) {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (this.sel_subcat2.length == 0) {
            // alert("Please Select Subcategory");
            this.$fire({
              text: "Please Select Subcategory",
              type: "warning",
              timer: 30000,
            });
          } else {
            // alert(this.editId)
            const Obj = {
              id: this.editId,
              brands: this.selected_brandID,
              sub_catid: this.sel_subcat2,
              cat_id: this.selected_catID,
              user_id: this.user_id,
              currentUserID: this.$route.params.id,
              brand_manager: userInfo[0].user_id,
            };

            axios
              .post(`${CONSTANTS.API_URL}/updateassigncatsubcatid`, Obj)
              .then((response) => {
                this.result = response.data;
                if (this.result.returnmsg === "Successful") {
                  (this.brand_id = []),
                    (this.sel_subcat = []),
                    (this.selected_cat_id = []);

                  this.$fire({
                    text: "Data Updated Successfully",
                    type: "success",
                    timer: 30000,
                  });

                  this.isEditModelVisible = !this.isEditModelVisible;

                  this.getassigncatsubctidlist();
                } else {
                  (this.brand_id = []),
                    (this.sel_subcat = []),
                    (this.selected_cat_id = []);
                  this.$fire({
                    text: "Something is wrong, Please try again",
                    type: "error",
                    timer: 30000,
                  });
                  this.isEditModelVisible = !this.isEditModelVisible;
                }
              });
          }
        }
      });
    },

    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          const Obj = {
            id: this.deleteId,
          };

          axios
            .post(`${CONSTANTS.API_URL}/deletecatsubcatid`, Obj)
            .then((response) => {
              this.result = response.data;
              if (this.result.returnmsg === "Successful") {
                this.$fire({
                  text: "Data Deleted Successfully",
                  type: "success",
                  timer: 30000,
                });

                this.isDeleteModelVisible = !this.isDeleteModelVisible;
                this.getassigncatsubctidlist();
              } else {
                this.$fire({
                  text: "Something is wrong, Please try again",
                  type: "error",
                  timer: 30000,
                });
                this.isDeleteModelVisible = !this.isDeleteModelVisible;
                this.getassigncatsubctidlist();
              }
            });
        }
      });
    },

    showEditModal(id, cat, brand, bid, cid, subcat_name, subcat_id) {
      this.sel_subcat2 = [];
      let subcat_id_int = subcat_id.split(",");
      console.log(subcat_id_int);
      subcat_id_int.map((item) => {
        this.sel_subcat2.push(parseInt(item));
      });
      console.log(this.sel_subcat2, "@@@@@@@@@@-this.sel_subcat2");

      this.editId = id;
      this.selected_brandID = bid;
      this.selected_catID = cid.split(" ");
      this.selected_catname = cat;
      this.selected_brandname = brand;

      this.getSubCat_edit_data(cid.split(","));
      this.isEditModelVisible = true;
    },

    showDeleteModal(id) {
      this.deleteId = id;
      this.isDeleteModelVisible = true;
    },

    cancel: function() {},

    cancelbtn: function() {
      this.$router.push("/usersdetails");
    },

    verifyUserPassword(userid){

      console.log(userid),
        console.log(this.oldpassword)
        // localStorage.setItem('useroldpass',this.oldpassword)
        // verifyUserPassword
        const Obj = {
          user_id: this.user_id,
          password: this.oldpassword,
          currentUserID:userid
        }

          axios
          .post(`${CONSTANTS.API_URL}/verifyUserPassword`, Obj)
          .then((response) => {
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              this.isPasswordverified = true,
              this.$fire({
                text: "Password verified successfully, You can now set new password",
                type: "success",
                timer: 30000,
              });
              this.oldpassword =""
            }else{
              this.$fire({
                text: "Please enter correct password",
                type: "error",
                timer: 30000,
              })

          }
        })

    },

    selectAllSubCat(checked){
      // alert(checked)
      this.sub_cat_arr1 = [];
      this.sel_subcat = [];
      if(checked == true){
                            
      for (let i = 0; i < this.sub_cat_arr.length; i++) {
            this.sub_cat_arr1.push(this.sub_cat_arr[i].sub_catid)
          
        }
        console.log("this.sub_cat_arr1")  
        console.log(this.sub_cat_arr1)  

       this.sub_cat_arr1.map((item) => {
        this.sel_subcat.push(parseInt(item));
      });
      console.log(this.sel_subcat, "@@@@@@@@@@-this.sel_subcat");
     
    }else{

        this.sub_cat_arr1.map((item) => {
          this.sel_subcat.pop(parseInt(item));
        });
      this.sel_subcat = [];
      console.log(this.sel_subcat, "@@@@@@@@@@-this.sel_subcat");

    }
    },


    selectAllSubCatForEdit(checked){
      // alert(checked)
      this.selectedsubcatarry = []
      this.sel_subcat2 = []

      
      if(checked == true){

          for (let j = 0; j < this.data_source2.length; j++) {
        
            this.selectedsubcatarry.push(this.data_source2[j].sub_catid)
            
          }
          // console.log("selectedsubcatarry",this.selectedsubcatarry)

          this.selectedsubcatarry.map((item) => {
            this.sel_subcat2.push(parseInt(item));
          });
          console.log(this.sel_subcat2, "@@@@@@@@@@-this.sel_subcat");
        

          }else{

            this.selectedsubcatarry.map((item) => {
            this.sel_subcat2.pop(parseInt(item));
            });
            this.sel_subcat2 = []
            console.log(this.sel_subcat2, "@@@@@@@@@@-this.sel_subcat");

          }

    
    },

    selectval(){
      // console.log(this.iscategoryselected)
      if(this.sel_subcat.length != this.sub_cat_arr.length){
            // this.iscategoryselected = false;
            // if(this.iscategoryselected = true){
               let checkbox = document.getElementById("checkbox");
               console.log("000000000000000000000000000",checkbox.checked)
                if (checkbox.checked ==true) {
                   console.log("0000TTTTTTTTTTTTT0000",checkbox.checked)
                  // checkbox.checked=false;
                  // this.iscategoryselected = false;
              } else {
                 console.log("000000FFFFFFFFFFFFFF0000000",checkbox.checked)
                  // checkbox.checked=true;
                  // this.iscategoryselected = true;
              }
            // }
            // console.log(this.iscategoryselected)
      }
    },

    selectval1(){
      console.log("this.sel_subcat2.length ",this.sel_subcat2.length )
      console.log("this.data_source2.length",this.data_source2.length)
       let checkbox = document.getElementById("checkbox1");
               console.log("0000####################",checkbox.checked)
       if(this.sel_subcat2.length == this.data_source2.length){
               checkbox.checked=true;
      }
      else{
               checkbox.checked=false;
      }

    },
    selectCategory(brandID){
      if (this.user_type == 'Admin'){
        this.getCategoryList()
      }else{
      const Obj = {
          user_id: this.user_id,
          brand_id: brandID
        }
          axios
          .post(`${CONSTANTS.API_URL}/getBMCategory`, Obj)
          .then((response) => {
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
            this.cat_arr = this.result.returnvalue;

            for (var j = 0; j <= this.cat_arr.length; j++) {
              this.cat_name_arr.push(this.cat_arr[j].category_title);
            }
            this.totalRows = this.result.returnvalue.length;
          }else if(response.data.returnmsg.toLowerCase() == "unsuccessful"){
            this.cat_arr = [];
            this.totalRows = 0;
            this.$fire({
                  text: response.data.returnvalue,
                  type: "error",
                  timer: 30000,
                });
          }else {
            this.cat_arr = [];
            this.totalRows = 0;
            this.$fire({
                  text: "Error while getting category",
                  type: "error",
                  timer: 30000,
            });
          }
        })
      }

    },
     selectSubCategory(cat_id,brand_id){
       if (this.user_type == 'Admin'){
        this.getSubCategoryList(cat_id)
         this.selectedCategories = cat_id
      }else{
      this.selectedCategories = cat_id
      const Obj = {
          user_id: this.user_id,
          brand_id: brand_id,
          cat_id: cat_id
        }
          axios
          .post(`${CONSTANTS.API_URL}/getBMSubCategory`, Obj)
          .then((response) => {
            console.log('response.data',response.data);
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.sub_cat_arr = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
          } else if (response.data.returnmsg.toLowerCase() == "unsuccessful") {
            this.sub_cat_arr = [];
            this.totalRows = 0;
            this.$fire({
            text: response.data.returnvalue,
            type: "error",
            timer: 30000,
          });
        } else{
          this.sub_cat_arr = [];
            this.totalRows = 0;
            this.$fire({
            text: 'Error while getting subcategory!',
            type: "error",
            timer: 30000,
          });
        }
       })
      }
     },
  } 
}

</script>
